const getFieldValue = (field) => (field ? field.value : null);
export default getFieldValue;
